import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLoginMutation } from "../../redux/slices/auth/authSlice.js";
import { CircularProgress } from "@mui/material";  
import {jwtDecode} from "jwt-decode";
import "../../styles/global.css/authform.css"; 

export default function AuthForm({ setUser }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const videoRef = useRef(null);
  const navigate = useNavigate();

  const [login] = useLoginMutation();

   
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await login({ email, password }).unwrap();

      if (!res?.token) {
        setError("Email və ya şifrə səhvdir!");
        setLoading(false);
        return;
      }
 
      localStorage.setItem("token", res.token);
      const decoded = jwtDecode(res.token);
      const isAdmin = String(decoded.admin).toLowerCase() === "true";
      
      setUser({ admin: isAdmin });
      navigate(isAdmin ? "/admin" : "/seller");

    } catch (err) {
      console.error("Login xətası:", err);
      setError("Email və ya şifrə səhvdir!");
    } finally {
      setLoading(false);
    }
  };

 
  const handleVideoEnd = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
  };
 
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!videoRef.current) return;
      if (!document.hidden) {
        videoRef.current.currentTime = 0;
        videoRef.current.play().catch(() => {});
      } else {
        videoRef.current.pause();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  
  

  return (
    <div className="auth-container">
      

 
      <div id="auth-video" className="auth-video" style={{ opacity: videoLoaded ? 1 : 0 }}>
        <video
          ref={videoRef}
          autoPlay
          muted
          preload="auto"
          onCanPlay={() => setVideoLoaded(true)}
          onEnded={handleVideoEnd}
        >
          <source src="/videos/videoplayback.webm" type="video/webm" />
          Sizin brauzer video dəstəkləmir.
        </video>
      </div>
 
      {videoLoaded && (
        <div className="auth-form-container">
          <div className="logo">
            <img draggable={false} src="/logo/autolux-logo.png" alt="Logo" />
          </div>

          <form onSubmit={handleLogin} className="auth-form">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button type="submit" disabled={loading} style={{ position: "relative" }}>
              {loading ? (
                <CircularProgress size={16} style={{ color: "#fff" }} />
              ) : (
                "Daxil ol"
              )}
            </button>

            {error && <p className="error">{error}</p>}
          </form>
        </div>
      )}
    </div>
  );
}
